const decodeBase64 = (data: string) => {
  return Buffer.from(data, 'base64').toString('ascii')
}

export default decodeBase64
